// Shared route helpers used to scope real-time calendar subscriptions
// (CalendarEvents, eventSyncSuccessNotice, eventSyncFailureNotice) to the
// Planner page only. Every other tab (Providers list, Clients list,
// Provider Details, etc.) should NOT register subscriber rows or show
// calendar-related toasts.

// All routes that render MainCalendarPage (the Planner).
export const PLANNER_ROUTE_PREFIXES: ReadonlyArray<string> = [
  '/planner',
  '/appointments/new',
  '/admin-appointments/new'
];

export const isPlannerRoute = (pathname: string | undefined | null): boolean => {
  if (!pathname) return false;
  return PLANNER_ROUTE_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
};
